import React, { useState } from 'react';
import ajaxConfig from '../../../util/remote/ajaxConfig';
import { useConfig } from '../../../DataStore/ConfigContext';
import Notification from '../../Common/Notification';
import BsModal from '../../Common/BsModal';
import TextInput from '../../Common/TextInput';

const NewUnitModal = () => {
  const [loading, setLoading] = useState(false);
  const [notify, setNotify] = useState(null);
  const {newUnit, setNewUnit} = useConfig();
  const [description, setDescription] = useState('');
  const [unitName, setUnitName] = useState('');


  const handleSave = async () => {
    if (unitName.length === 0 || description.length === 0) {
      setNotify(<Notification type='danger' message='All fields are required' />);
      return;
    }

    setLoading(true);
    const server_response = await ajaxConfig.createSubjectUnit(newUnit.subject.subject_id, unitName, description);
    setLoading(false);
    if (server_response.status === "OK") {
      newUnit.callback();
      setNotify(<Notification type='success' message={server_response.message} />);
      setUnitName('');
      setDescription('');

    } else {
      setNotify(<Notification type='danger' message={server_response.message} />);
    }
  };

  const closeModal = () => {
    setNotify(null);
    setNewUnit({ show: false, subject: null });
  };


  return (
    <BsModal
      show={newUnit.show}
      onClose={closeModal}
      title={`New ${newUnit.subject?.subject} Unit`}
      footer={
        <>
          <button type="button" className="btn btn-secondary" onClick={closeModal}>
            Cancel
          </button>
          <button
            className="btn btn-success"
            disabled={loading || !unitName || !description}
            onClick={handleSave}
          >
            <i className="fa fa-plus-circle mr-1"></i> Save Subject Unit
          </button>
        </>
      }
    >
      <TextInput
        label="Unit Name"
        placeholder="Unit Name"
        leftIcon="fa fa-book"
        value={unitName}
        onChange={e => setUnitName(e.target.value)}
        required
      />

      <TextInput
        label="Description"
        placeholder="Unit Description"
        leftIcon="fa fa-info-circle"
        value={description}
        onChange={e => setDescription(e.target.value)}
        required
      />
     

      {loading && <div className="mt-3"><i className="fa fa-spinner fa-spin"></i> Saving...</div>}
      {notify}
    </BsModal>
  );
};

export default NewUnitModal;
